import React from "react";

const STEPS = [
  {
    n: "01",
    title: "Complete a brief 5-minute assessment.",
  },
  {
    n: "02",
    title: "Receive your Visibility Score™.",
  },
  {
    n: "03",
    title: "Review your personalized Visibility Report™.",
  },
  {
    n: "04",
    title:
      "Identify practical opportunities to improve communication, recognition, engagement, and visibility.",
  },
];

export default function VCHowItWorks() {
  return (
    <section
      id="vc-how-it-works"
      data-testid="vc-how-it-works-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            How it works
          </div>
          <h2
            data-testid="vc-how-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            From Assessment to Insight in{" "}
            <span className="text-teal">Five Minutes.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`vc-how-step-${i}`}
              className="group relative bg-white hover:border-teal/40 border border-slate-200 rounded-2xl p-7 transition-all duration-300 hover:shadow-lg flex flex-col"
            >
              <div className="flex items-baseline gap-3 mb-5">
                <span className="font-serif text-4xl font-black text-teal leading-none">
                  {s.n}
                </span>
                <span className="h-px flex-1 bg-slate-200 group-hover:bg-teal/40 transition-colors" />
              </div>
              <p className="font-serif text-base md:text-lg font-bold text-navy leading-snug">
                {s.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
